import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ComptaStockPage from "./pages/ComptaStockPage";
import InventairePage from "./pages/InventairePage";
import { useEffect } from "react";
import { toast } from "sonner";
import "./App.css";

const SessionExpiredHandler = () => {
  const { sessionExpired, clearSessionExpired } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (sessionExpired && location.pathname !== "/login") {
      toast.error("Votre session a expiré, veuillez vous reconnecter", { duration: 5000 });
      clearSessionExpired();
    }
  }, [sessionExpired, location.pathname, clearSessionExpired]);

  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user, loading, sessionExpired } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="animate-pulse text-[#525252]">Chargement...</div>
      </div>
    );
  }

  if (!user) {
    // Save intended destination for post-login redirect
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="animate-pulse text-[#525252]">Chargement...</div>
      </div>
    );
  }

  if (user) {
    // Redirect to returnTo if present
    const params = new URLSearchParams(location.search);
    const returnTo = params.get("returnTo") || "/";
    return <Navigate to={returnTo} replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SessionExpiredHandler />
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/compta" element={
            <ProtectedRoute>
              <ComptaStockPage />
            </ProtectedRoute>
          } />
          <Route path="/inventaire" element={
            <ProtectedRoute>
              <InventairePage />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
